export default class StepsStorage {
    constructor() {
        this.dom = {

        };

        this.ls = window.sessionStorage;

        this.init();
    }

    init() {

    }

    save(key, data) {
        this.ls.setItem(key, JSON.stringify(data));
    }

    get(key) {
        return JSON.parse(this.ls.getItem(key));
    }
}
